import { Badge, Tabs } from 'antd';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import { ROUTES, TABS } from '../../../../../common/constants';

const NewTabs = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const [activeTabKey, setActiveTabKey] = useState(TABS?.DELIVERY?.key);
  const blinkingDotEl = useMemo(
    () => <Badge status="processing" color="red" className="custom-badge" />,
    [],
  );

  const {
    state: { orderCount },
  } = useContext(AppContext);
  const tabList = [
    {
      key: TABS?.CONFIRM_ORDER?.key,
      label: (
        <div className="d-flex align-center gap-10">
          {`${TABS?.CONFIRM_ORDER?.label} ${
            orderCount?.newOrderCount || orderCount?.newOrderCount === 0
              ? `(${orderCount?.newOrderCount})`
              : ''
          } `}
          {orderCount?.placedOrderCount > 0 ? blinkingDotEl : null}
        </div>
      ),
      children,
    },
    {
      key: TABS?.FULFILMENT_POSSIBILITY?.key,
      label: (
        <div className="d-flex align-center gap-10">
          {`${TABS?.FULFILMENT_POSSIBILITY?.label} ${
            orderCount?.fulfilmentPossibilityOrderCount ||
            orderCount?.fulfilmentPossibilityOrderCount === 0
              ? `(${orderCount?.fulfilmentPossibilityOrderCount})`
              : ''
          } `}
          {orderCount?.fulfilmentPossibilityOrderCount > 0
            ? blinkingDotEl
            : null}
        </div>
      ),
      children,
    },
    {
      key: TABS?.ASSIGN_DELIVERY_PARTNER?.key,
      label: (
        <div className="d-flex align-center gap-10">
          {`${TABS?.ASSIGN_DELIVERY_PARTNER?.label} ${
            orderCount?.confirmedOrderCount ||
            orderCount?.confirmedOrderCount === 0
              ? `(${orderCount?.confirmedOrderCount})`
              : ''
          } `}
          {orderCount?.remainingConfirmedOrderCount > 0 ? blinkingDotEl : null}
        </div>
      ),
      children,
    },
    {
      key: TABS?.RETURN?.key,
      label: (
        <div className="d-flex align-center gap-10">
          {`${TABS?.RETURN?.label} ${orderCount?.returnOrderCount || orderCount?.returnOrderCount === 0
              ? `(${orderCount?.returnOrderCount})`
              : ''
            } `}
          {orderCount?.returnRequestedOrderCount > 0 ? blinkingDotEl : null}
        </div>
      ),
      children,
    },
  ];

  useEffect(() => {
    if (location?.pathname?.includes(ROUTES?.NEW)) {
      setActiveTabKey(TABS?.CONFIRM_ORDER?.key);
    }
    if (location?.pathname?.includes(ROUTES?.FULFILMENT_POSSIBILITY)) {
      setActiveTabKey(TABS?.FULFILMENT_POSSIBILITY?.key);
    }
    if (location?.pathname?.includes(ROUTES?.ASSIGN_DELIVERY_PARTNER)) {
      setActiveTabKey(TABS?.ASSIGN_DELIVERY_PARTNER?.key);
    }
    if (location?.pathname?.includes(ROUTES?.RETURN)) {
      setActiveTabKey(TABS?.RETURN?.key);
    }

  }, [location]);

  const onTabChange = (key) => {
    setActiveTabKey(key);
    switch (key) {
      case TABS?.CONFIRM_ORDER?.key:
        history?.push(
          `${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.CONFIRM_ORDER}`,
        );
        break;
      case TABS?.FULFILMENT_POSSIBILITY?.key:
        history?.push(
          `${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.FULFILMENT_POSSIBILITY}`,
        );
        break;
      case TABS?.ASSIGN_DELIVERY_PARTNER?.key:
        history?.push(
          `${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.ASSIGN_DELIVERY_PARTNER}`,
        );
        break;
      case TABS?.RETURN?.key:
        history?.push(
          `${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.RETURN}`,
        );
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="card-container mobile-card-main">
        <Tabs
          activeKey={activeTabKey}
          type="card"
          className="full-width"
          onChange={(key) => onTabChange(key)}
          items={tabList}
          destroyInactiveTabPane
        />
      </div>
    </>
  );
};

export default NewTabs;
